import EventBus from "@/helpers/EventBus";
import router from "@/router/router";

const Default = {
    defaultTabId: null,
    activeClasses: "text-[#053183] hover:text-[#053183] border-[#053183] border-b-2",
    inactiveClasses: "text-gray-500 hover:text-gray-600 border-gray-100 hover:border-gray-300 border-b-0",
    lazyLoad: false, //  lazy load tab
    queryTab: false, // redirect tab
    id: "undefined", // idTabs
    onShow: (e, tab) => {
        if (e._options.lazyLoad) {

            EventBus.$emit(`${ e._options.id }-onShowTab`, tab.id);

            if (e._options.queryTab) {
                const selectedTab = router.currentRoute.query?.tab;
                if (selectedTab !== tab.id) {
                    router.replace({query: {tab: tab.id}})
                }
            }

        }
    }
}

class Tabs {
    constructor(items = [], options = {}) {
        this._items = items
        this._activeTab = options ? this.getTab(options.defaultTabId) : null
        this._options = {...Default, ...options}
        this._init()
    }

    _init() {
        if (this._items.length) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) {
                this._setActiveTab(this._items[0])
            }

            // force show the first default tab
            this.show(this._activeTab.id, true)

            // show tab content based on click
            this._items.map(tab => {
                tab.triggerEl.addEventListener("click", () => {
                    this.show(tab.id)
                })
            })
        }
    }

    getActiveTab() {
        return this._activeTab
    }

    _setActiveTab(tab) {
        this._activeTab = tab
    }

    getTab(id) {
        return this._items.filter(t => t.id === id)[0]
    }

    show(id, forceShow = false) {
        const tab = this.getTab(id)
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) {
            return
        }

        // hide other tabs
        this._items.map(t => {
            if (t !== tab) {
                t.triggerEl.classList.remove(...this._options.activeClasses.split(" "));
                t.triggerEl.classList.add(...this._options.inactiveClasses.split(" "));
                t.targetEl.classList.add("hidden")
                t.triggerEl.setAttribute("aria-selected", false)
            }
        })

        // show active tab
        tab.triggerEl.classList.add(...this._options.activeClasses.split(" "));
        tab.triggerEl.classList.remove(...this._options.inactiveClasses.split(" "));
        tab.triggerEl.setAttribute("aria-selected", true)
        tab.targetEl.classList.remove("hidden")

        this._setActiveTab(tab)

        // callback function
        this._options.onShow(this, tab)
    }

}

window.Tabs = Tabs;

export function initTabs({lazyLoad, queryTab, id}) {
    const triggerEl = document.querySelector(`#${ id } [data-tabs-toggle]`);

    const tabElements = []
    let defaultTabId = null
    triggerEl.querySelectorAll("[role=\"tab\"]").forEach(el => {
        const isActive = el.getAttribute("aria-selected") === "true"
        const tab = {
            id: el.getAttribute("data-tabs-target"),
            triggerEl: el,
            targetEl: document.querySelector(el.getAttribute("data-tabs-target"))
        }
        tabElements.push(tab)

        if (isActive) {
            defaultTabId = tab.id
        }
    })
    const selectedTab = router.currentRoute.query?.tab;

    if (selectedTab) {
        defaultTabId = selectedTab;
    }
    return new Tabs(tabElements, {
        defaultTabId: defaultTabId,
        lazyLoad,
        queryTab,
        id
    })

}

export default Tabs;
